import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  FormControl,
  Input,
  FormLabel,
  Select,
  useToast,
} from "@chakra-ui/react";
import BookingDataService from "../../services/Booking";
import React, { useState } from "react";
import { Spinner } from "@chakra-ui/react";
export default function DownloadPaymentModal({ isOpen, onClose }: any) {
  const toast = useToast();
  // const [value, setValue] = useState(Data.filterType);
  // const [lock, setLock] = useState(isLock);
  const [downloadLoader, setdownloadLoader] = useState<any>(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  const initialRef = React.useRef(null);
  const handleSubmit = () => {
    setdownloadLoader(true);
    BookingDataService.downloadPaymentDetails(fromDate, toDate)
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${fromDate}to${toDate}.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast({
          position: "top",
          title: "Billing Sheet Downloaded Successfully",
          description: "The billing sheet has been downloaded successfully",
          status: "success",
          duration: 1500,
          isClosable: true,
        });
      })
      .catch((error) => {
        console.error("Error downloading payments:", error.message);
        toast({
          position: "top",
          title: "Billing Sheet Download Failed",
          description:
            "There was an error downloading the billing sheet. Please try again later.",
          status: "error",
          duration: 1500,
          isClosable: true,
        });
      })
      .finally(() => {
        setdownloadLoader(false);
        onClose();
      });
  };
  function getTodayDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
  function getFirstDateOfCurrentMonth() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = "01";
    return `${year}-${month}-${day}`;
  }
  const handleSelecion = (value: any) => {
    if (value === "today") {
      setFromDate(getTodayDate);
      setToDate(getTodayDate);
    } else if (value === "month") {
      setFromDate(getFirstDateOfCurrentMonth);
      setToDate(getTodayDate);
    } else {
      setFromDate("");
      setToDate("");
    }
    setSelectedValue(value);
  };
  return (
    <>
      <Modal initialFocusRef={initialRef} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Choose Date Range</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <FormControl>
              <Select
                value={selectedValue}
                onChange={(e) => handleSelecion(e.target.value)}
              >
                <option value="">Choose Time</option>
                <option value="today">Today</option>
                <option value="month">Current Month</option>
                <option value="all">All Payments</option>
              </Select>
            </FormControl>
            <FormControl>
              <FormLabel>From</FormLabel>
              <Input
                value={fromDate}
                type="date"
                ref={initialRef}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </FormControl>

            <FormControl mt={2}>
              <FormLabel>To</FormLabel>
              <Input
                value={toDate}
                type="date"
                ref={initialRef}
                onChange={(e) => setToDate(e.target.value)}
              />
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button
              bgColor="#327171"
              color={"white"}
              mr={3}
              onClick={handleSubmit}
            >
              {downloadLoader ? <Spinner size="sm" /> : "Download"}
            </Button>
            <Button bgColor="red" color={"white"} onClick={onClose}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
